var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseractivityreport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0168 51.001V47.9122C23.0168 46.2737 22.3659 44.7024 21.2073 43.5438C20.0488 42.3852 18.4774 41.7344 16.839 41.7344H7.57231C5.93386 41.7344 4.36252 42.3852 3.20396 43.5438C2.0454 44.7024 1.39453 46.2737 1.39453 47.9122V51.001",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2056 35.5548C15.6175 35.5548 18.3834 32.7889 18.3834 29.377C18.3834 25.9651 15.6175 23.1992 12.2056 23.1992C8.79372 23.1992 6.02783 25.9651 6.02783 29.377C6.02783 32.7889 8.79372 35.5548 12.2056 35.5548Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4058 19.5015L10.4058 5.44601C10.4058 3.87506 11.6992 2.60156 13.2947 2.60156H33.5169C35.1124 2.60156 36.4058 3.87506 36.4058 5.44601V25.3571C36.4058 26.9281 35.1124 28.2016 33.5169 28.2016H21.9502",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2056 1V3.8",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6055 1V3.8",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4058 11H36.4058",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.0059,
    y: 32.6016,
    width: 6.4,
    height: 18.4,
    rx: 2,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6055,
    y: 41.8008,
    width: 6.4,
    height: 9.2,
    rx: 2,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2056,
    y: 10.6016,
    width: 6.4,
    height: 40.4,
    rx: 2,
    stroke: "#444444",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseractivityreport);
export default __webpack_public_path__ + "static/media/user activity report.7d61b767c77933503a726b58e83b4438.svg";
export { ForwardRef as ReactComponent };